import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBillToOverrideTable extends Layout {
    sourceBolBillToOverride: DataSource;
    tableBillToOverride: Table;
}
